interface IconProps {
  name: string;
  width?: number | string;
  height?: number | string;
  className?: string;
}

const Icon = ({ name, width, height, className }: IconProps) => (
  <svg className={className} width={width} height={height}>
    <use xlinkHref={`/sprite.svg#${name}`} />
  </svg>
);

export default Icon;
